<template>
  <UIcon :name="icon" mode="css" class="flex-none bg-primary"/>
</template>

<script setup lang="ts">
defineProps({
  icon: { type: String, default: 'i-svg-spinners-ring-resize' },
});
</script>